import React from 'react';
import { IoMdClose, IoMdCheckmark } from 'react-icons/io';

const PaymentSuccessPopup = ({ onClose, onGoToDownloads, onVisitSettings }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#000000A3] backdrop-blur-[1px] z-[200] p-4">
      <div className="relative w-full max-w-2xl">
        <div className="md:w-20 w-16 md:h-20 h-16 absolute md:-top-2 -top-2 left-1/2 -translate-x-1/2 bg-white rounded-full flex items-center justify-center z-10">
          <div className="flex items-center justify-center md:w-16 w-12 md:h-16 h-12 bg-blue-100 rounded-full">
            <div className="md:w-10 w-8 md:h-10 h-8 bg-blue-500 rounded-full flex items-center justify-center">
              <IoMdCheckmark className="text-white md:text-2xl text-xl" strokeWidth={3} />
            </div>
          </div>
        </div>

        {/* Main content container */}
        <div className="bg-white rounded-3xl md:mt-10 mt-8 overflow-hidden">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-14 right-4 text-black hover:text-gray-700 transition-colors z-10"
            aria-label="Close"
          >
            <IoMdClose size={24} />
          </button>

          {/* Content */}
          <div className="text-center px-8 pt-16 pb-12">
            <h1 className="md:text-5xl text-4xl font-bold text-blue-500 mb-6">
              Thank you!
            </h1>
            
            <h2 className="md:text-4xl text-3xl font-bold text-black mb-6 leading-tight">
              Your payment has been processed successfully.
            </h2>
            
            <p className="text-gray-500 md:text-xl text-lg mb-10">
              Your access is now active and all features are unlocked.
            </p>

            {/* Buttons */}
            <div className="space-y-4">
              <button 
                onClick={onGoToDownloads}
                className="w-full bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] text-white md:text-xl text-lg font-semibold md:py-5 py-4 px-8 rounded-full hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                Go to Downloads
              </button>
              
              <button 
                onClick={onVisitSettings}
                className="text-black md:text-lg text-base font-medium underline hover:text-blue-600 transition-colors"
              >
                Visit Settings
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPopup;